import { render, staticRenderFns } from "./mAboutour.vue?vue&type=template&id=05517caa&scoped=true&"
import script from "./mAboutour.vue?vue&type=script&lang=js&"
export * from "./mAboutour.vue?vue&type=script&lang=js&"
import style0 from "./mAboutour.vue?vue&type=style&index=0&id=05517caa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05517caa",
  null
  
)

export default component.exports